<div class="container">
  <ng-container *ngFor="let statistic of leagueService.leagueStatistics">
    <h3>{{statistic.ui_name}}</h3>
    <lib-league-statistics-table [league]="leagueService.currentLeague"
                                 [type]="statistic.type"
                                 [openLinksInNewTab]="false"
                                 [colorScheme]="ColorScheme.Dark"
                                 [statistic]="statistic"></lib-league-statistics-table>
  </ng-container>
</div>
